
export enum ProductCodes {
  SGXESGenome = 'company_tracker_light',
  CompanyTrackerStarter = 'company_tracker_starter',
  CompanyTracker = 'company_tracker',
  CompanyTrackerPro = 'company_tracker_pro',
  CompanyTrackerEnterprise = 'company_tracker_enterprise',
  PortfolioTracker = 'portfolio_tracker',
  MaterialityTracker = 'materiality_assessment',
  MaterialityTrackerSolopreneur = 'materiality_assessment_solopreneur',
  MaterialityTrackerStartup = 'materiality_assessment_startup',
  MaterialityTrackerMicro = 'materiality_assessment_micro',
  MaterialityTrackerSME = 'materiality_assessment_sme',
  MaterialityTrackerMidCap = 'materiality_assessment_midcap',
  MaterialityTrackerMNC = 'materiality_assessment_mnc',
  MaterialityTrackerLarge = 'materiality_assessment_large',
  EmissionTracker = 'emission_tracker',
  EmissionTrackerGPT = 'emission_tracker_gpt',
  EmissionTrackerUnravel = 'emission_tracker_unravel',
}
